import React, { FC } from 'react';
import Container from '../../../../../Common/Container/Container';
import * as classes from './TitleSection.module.scss';

const TitleSection: FC = ({ children }) => {
  return (
    <section data-aos='fade-in'>
      <Container>
        <h1 className={classes.element}>{children}</h1>
      </Container>
    </section>
  );
};

export default TitleSection;
